// extracted by mini-css-extract-plugin
module.exports = {"bot":"Buttons_bot__d6x9w","btn":"Buttons_btn__t_Pt2"};